import { createAsyncThunk } from "@reduxjs/toolkit";
import { getShopWifi, updateShopWifi } from "../../helpers/backend_helper";

export interface UpdateShopWifiPayload {
    shopId: string | number;
    data: Record<string, any>;
}

export const getWifiInfo = createAsyncThunk(
    "ShopWifi/getWifiInfo",
    async (shopId: string | number, { rejectWithValue }) => {
        try {
            return await getShopWifi(shopId);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateWifiInfo = createAsyncThunk(
    "ShopWifi/updateWifiInfo",
    async ({ shopId, data }: UpdateShopWifiPayload, { rejectWithValue }) => {
        try {
            const response = await updateShopWifi(shopId, data);
            return { shopId, response };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
